import { POST } from "../../index";
export const query = (param) => POST("/v1/RoleController/query", param);
export const queryPage = (param) => POST("/v1/RoleController/queryPage", param);
export const insertRole = (param) => POST("/v1/RoleController/insertRole", param);
export const updateRole = (param) => POST("/v1/RoleController/updateRole", param);
export const deleteByid = (param) => POST("/v1/RoleController/deleteByid", param);
export const selectTemplateRole = (param) => POST("/v1/RoleController/selectTemplateRole", param);
